// Function to calculate a new fractional index
export default function calculateFractionalIndex(before, after) {
  if (!before && before !== 0) return parseFloat(after) - 1;
  if (!after) return parseFloat(before) + 1;
  return (parseFloat(before) + parseFloat(after)) / 2;
}
